import { render, staticRenderFns } from "./AssetImage.vue?vue&type=template&id=6b40a27a"
import script from "./AssetImage.vue?vue&type=script&lang=js"
export * from "./AssetImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports